import { useEffect } from "react";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";

export default function StepThankYou() {
	const { complete, data } = useFeedbackFlow();

	useEffect(() => {
		complete();
	}, [complete]);

	const isNegativePath = data.rating >= 1 && data.rating <= 3;

	return (
		<StepLayout
			header={
				<div>
					<div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
						<svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
						</svg>
					</div>
					<h1 className="text-2xl font-semibold text-primary text-center">Thank you!</h1>
				</div>
			}
			content={
				<div>
					{isNegativePath ? (
						<p className="text-secondary mx-auto text-center">
							We appreciate you taking the time to share your feedback. Your input helps us improve and build a better product for everyone.
						</p>
					) : (
						<p className="text-secondary mx-auto text-center">
							Your testimonial has been submitted successfully. We truly appreciate you taking the time to share your experience with us.
						</p>
					)}
				</div>
			}
			footer={
				<div className="text-center pt-6 border-t border-gray-100">
					<p className="text-sm text-tertiary">You can safely close this page now.</p>
				</div>
			}
		/>
	);
}
